import { Component, Inject, OnInit, Input, HostListener} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { NCESAPIService } from './nces.service';
import { UtilityService } from '../utility/utility.service';

@Component({
	templateUrl: './nces-logo-cover-update.dialog.html',
	styleUrls: ['./nces-logo-cover.scss'],
	standalone: false
})
export class NCESLogoCoverUpdateDialog {
	constructor(
		private ncesAPI: NCESAPIService,
		private utilitySrv: UtilityService,
		private dialogRef: MatDialogRef<NCESLogoCoverUpdateDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.type = data?.imgType ?? "";
		this.schoolId = data?.schoolId ?? "";
	}

	type: string = "";
	schoolId: string = "";
	myImage: any = "";
	imageCropped: boolean = false;
	myCroppedImage: any;
	myDisplayCroppedImage: any;
	displayAvatarFlag: boolean = false;
	savingFile: boolean = false;
	openningFile: boolean = false;
	showMinimize:boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event'])
	onResize(e: any): void {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	openFile(evt: any) {
		this.openningFile = true;
		let file = evt.currentTarget.files[0];
		let reader = new FileReader();
		reader.onload = (evt) => {
			this.myImage = evt.target.result;
			let image = new Image() as HTMLImageElement;
			image.src = evt.target.result.toString();
			image.onload = (e: any) => {
				this.openningFile = false;
				this.openImageModal(this.myImage);
			};
		}

		reader.readAsDataURL(file);
		var fileInput = document.getElementById('fileInput') as HTMLInputElement;
		fileInput.value = '';
	};

	private openImageModal(img: any) {
		let imgType: "circle" | "rectangle" = this.type === "logo" ? "circle" : "rectangle";
		this.utilitySrv.openImageCropper(imgType, img).subscribe(
			croppedImg => {
				this.imageCropped = false;
				if (croppedImg !== null) {
					this.myCroppedImage = croppedImg;
					this.imageCropped = true;
					this.displayAvatarFlag = false;
					if (this.type !== 'logo') {
						this.myDisplayCroppedImage = this.myCroppedImage;
					}
				}
				else {
					this.myDisplayCroppedImage = null;
					this.myCroppedImage = null;
					this.imageCropped = false;
				}
			}
		);
	}

	cancel() {
		this.dialogRef.close("cancel");
	}

	save() {
		if (this.imageCropped === false || this.myCroppedImage.length === 0) {
			this.dialogRef.close("cancel");
			return;
		}
		else {
			this.savingFile = true;
			let img: string = "";
			if (this.myCroppedImage.split(',')[0].indexOf('base64') >= 0) {
				img = this.myCroppedImage.split(',')[1];
			}
			else {
				img = this.myCroppedImage;
			}
			if (this.type === 'logo') {
				this.ncesAPI.saveNCESLogo(this.schoolId, img).subscribe(
					result => {
						this.savingFile = false;
						this.dialogRef.close("saved");
					},
					error => {
						this.savingFile = false;
						console.log(error);
					}
				);
			}
			else {
				this.ncesAPI.saveNCESSplash(this.schoolId, img).subscribe(
					result => {
						this.savingFile = false;
						this.dialogRef.close("saved");
					},
					error => {
						this.savingFile = false;
						console.log(error);
					}
				);
			}
		}
	}

	removeImage() {
		this.imageCropped = false;
		this.displayAvatarFlag = false;
		this.myCroppedImage = null;
	}
}


@Component({
	selector: 'app-nces-logo-cover',
	templateUrl: './nces-logo-cover.component.html',
	styleUrls: ['./nces-logo-cover.scss'],
	standalone: false
})
export class NCESLogoCoverComponent implements OnInit {
	@Input() schoolId: string = "";
	@Input() logoImage: string = "";
	@Input() coverImage: string = "";
	@Input() schoolName: string = "";
	@Input() schoolUrl: string = "";
	@Input() city: string = "";
	@Input() state: string = "";
	@Input() zipCode: string = "";
	@Input() location: any = null; // {Latitude: "32.8015", Longitude: "-117.127"}

	constructor(
		private userInfo: UserInfoService,
		private dialog: MatDialog,
		private ncesAPI: NCESAPIService,
	) { }

	toggled = AppSettingService.widgetMobile();
	showMinimize = AppSettingService.widgetMobile();
	changingImage:boolean = false;
	defaultLogo: string = "";
	defaultSplash: string = "";
	logo: string = "";
	splash: string = "";
	name: string = "";
	schoolAddress: string = "";
	mapOnly: boolean = true;

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.setDisplay();
	}

	private setDisplay(): void {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
	}

	isEditor():boolean {
		return this.userInfo.getProfile().PersonId === "-1" ? true : false;
	}

	splashConfigOpen:boolean = false;
	logoConfigOpen: boolean = false;

	editMode(e: any, type: string, val: boolean): void {
		//console.log(e);
		if (this.isEditor()) {
			this.splashConfigOpen = false;
			this.logoConfigOpen = false;
			if (val === true) {
				e.target.style.filter = 'brightness(20%)';
				e.target.style.cursor = 'pointer';
				if (type === 'logo') {
					this.logoConfigOpen = true;
				}
				else {
					this.splashConfigOpen = true;
				}
			}
			else {
				e.target.style.filter = 'brightness(100%)';
				e.target.style.cursor = 'default';
			}
		}
		else {
			e.currentTarget.style.cursor = 'default';
		}
	}

	editImage(e: any, imgType: string): void {
		if (this.isEditor()) {
			let maxWidth: string = this.showMinimize ? "99vw" : "850px";
			let popup = this.dialog.open(
				NCESLogoCoverUpdateDialog,
				{
					disableClose: true,
					panelClass: 'jmDialogNoScroll',
					maxWidth: maxWidth,
					width: '100%',
					data: {
						schoolId: this.schoolId,
						imgType: imgType
					}
				}
			);
			popup.afterClosed().subscribe(
				choice => {
					if (choice == 'saved') {
						this.refreshImage();
					}
				}
			);
		}
	}

	private refreshImage(): void {
		this.changingImage = true;
		this.ncesAPI.getNCESSchool(this.schoolId).subscribe({
			next: (response: any) => {
				if (response != null && response.Object != null) {
					// if school id is provided, try to get the customized school logo and splash
					if (this.schoolId !== '') {
						this.logo = '/JourneyMedia/NCES/' + this.schoolId + '_logo.png?' + new Date().getTime();
						this.splash = '/JourneyMedia/NCES/' + this.schoolId + '_splash.png?' + new Date().getTime();
					}
					else {
						this.logo = response.data.Object.LogoImage == null ? this.defaultLogo : response.data.Object.LogoImage;
						this.splash = response.data.Object.CoverImage == null ? this.defaultSplash : response.data.Object.CoverImage;
					}
				}
				this.changingImage = false;
			},
			error: (err) => {
				console.log(err);
				this.changingImage = false;
			}
		});
	}


	ngOnInit(): void {
		this.defaultLogo = this.logoImage !== '' ? this.logoImage : '/API/Images/Institution/Logo.png';
		this.defaultSplash = this.coverImage !== '' ? this.coverImage : '/API/Images/Institution/Splash.png';
		this.logo = this.defaultLogo;
		this.splash = this.defaultSplash;
		// avoid server cache, try to get the customized school logo and splash 
		if (this.schoolId !== '') {
			this.logo = '/JourneyMedia/NCES/' + this.schoolId + '_logo.png?' + new Date().getTime();
			this.splash = '/JourneyMedia/NCES/' + this.schoolId + '_splash.png?' + new Date().getTime();
		}
		this.name = this.schoolName == null ? '' : this.schoolName.trim();
		this.schoolAddress = this.city + ', ' + this.state + ' ' + this.zipCode;
		if (this.name !== '') {
			this.name += this.name[this.name.length - 1].toLowerCase() == 's' ? "'" : "'s";
		}
		this.setDisplay();
	}
}
